import { apiClient } from "./client";

export interface UtenteAssegnabile {
  id: string;
  full_name: string | null;
  email: string;
  role: string;
}

/**
 * Utenti a cui si può assegnare un record posseduto da quelle organizzazioni.
 *
 * I proprietari si passano come parametri, non come id di record, perché il
 * select serve anche in creazione — quando il record non esiste ancora e i
 * suoi legami sono solo quelli appena scelti nel form.
 */
export async function listAssegnabili(proprietario: {
  cliente_id?: string | null;
  centro_assistenza_id?: string | null;
  istituto_vigilanza_id?: string | null;
  /** Sopralluogo esistente: il backend aggiunge i centri con cui è condiviso. */
  sopralluogo_id?: string | null;
}): Promise<{ utenti: UtenteAssegnabile[] }> {
  const params: Record<string, string> = {};
  if (proprietario.cliente_id) params.cliente_id = proprietario.cliente_id;
  if (proprietario.centro_assistenza_id) params.centro_assistenza_id = proprietario.centro_assistenza_id;
  if (proprietario.istituto_vigilanza_id) params.istituto_vigilanza_id = proprietario.istituto_vigilanza_id;
  if (proprietario.sopralluogo_id) params.sopralluogo_id = proprietario.sopralluogo_id;
  const { data } = await apiClient.get<{ utenti: UtenteAssegnabile[] }>("/assegnabili", { params });
  return data;
}
